import { Typography } from '@mui/material';
import React from 'react';

export default function PercentageText({ value }: { value: string | number }) {
  return (
    <Typography
      variant="h6"
      style={{
        fontFamily: 'Mulish, sans-serif',
        fontSize: '1.375rem', // Matches 22px font size
        fontWeight: 700, // Bold text
        color: '#242C2C', // Matches the color from Figma
        lineHeight: '150%', // 150% line height
        fontStyle: 'normal',
      }}
    >
      {value ? `${value}%` : ''}
    </Typography>
  );
}
